module.exports = "img/6.f49f63.webp";